// Normalized id for URLs/APIs: always string or null (numeric inputs become string; UUIDs unchanged).
function toNumberOrNull (value) {
  if (value === null || value === undefined || value === '') {
    return null
  }
  if (typeof value === 'number') {
    return Number.isNaN(value) ? null : String(value)
  }
  const str = String(value).trim()
  return str === '' ? null : str
}

export default toNumberOrNull
